import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-[#0A0E27] via-[#1E293B] to-[#0F172A] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#00D4FF] rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#9D4EDD] rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#00D4FF]/10 to-[#9D4EDD]/10 rounded-3xl p-8 lg:p-16 border border-[#00D4FF]/20 text-center">
            <div className="inline-flex items-center space-x-2 bg-[#1E293B] rounded-full px-6 py-3 mb-8">
              <Icon name="Rocket" size={20} color="#00D4FF" />
              <span className="text-sm font-medium text-[#00D4FF]">
                Начните прямо сейчас
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-headline font-bold text-white mb-6">
              Готовы трансформировать
              <br />
              <span className="bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] bg-clip-text text-transparent">
                ваш бизнес с AI?
              </span>
            </h2>

            <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed">
              Присоединяйтесь к сотням компаний в Казахстане, которые уже автоматизировали свои процессы и увеличили эффективность с Jetu AI
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Button
                variant="default"
                size="lg"
                iconName="Zap"
                iconPosition="right"
                onClick={() => window.open('https://wa.me/77476660065', '_blank')}
                className="w-full sm:w-auto"
              >
                Начать бесплатный пробный период
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                onClick={() => window.location.href = '/contact-support'}
                className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-white/20 text-white hover:bg-white/20"
              >
                Запланировать демо
              </Button>
            </div>

            <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#00D4FF] to-[#9D4EDD] rounded-xl flex items-center justify-center mb-3">
                  <Icon name="CheckCircle" size={24} color="#FFFFFF" />
                </div>
                <p className="text-white font-semibold mb-1">Без кредитной карты</p>
                <p className="text-gray-400 text-sm">14 дней бесплатно</p>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#00D4FF] to-[#9D4EDD] rounded-xl flex items-center justify-center mb-3">
                  <Icon name="Users" size={24} color="#FFFFFF" />
                </div>
                <p className="text-white font-semibold mb-1">Поддержка 24/7</p>
                <p className="text-gray-400 text-sm">На русском языке</p>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#00D4FF] to-[#9D4EDD] rounded-xl flex items-center justify-center mb-3">
                  <Icon name="Shield" size={24} color="#FFFFFF" />
                </div>
                <p className="text-white font-semibold mb-1">Безопасность данных</p>
                <p className="text-gray-400 text-sm">GDPR совместимость</p>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10">
              <p className="text-gray-400 text-sm mb-4">
                Доверяют более 500+ компаний в Казахстане
              </p>
              <div className="flex items-center justify-center space-x-8 opacity-50">
                <Icon name="Building" size={32} color="#FFFFFF" />
                <Icon name="Store" size={32} color="#FFFFFF" />
                <Icon name="Briefcase" size={32} color="#FFFFFF" />
                <Icon name="ShoppingBag" size={32} color="#FFFFFF" />
                <Icon name="Truck" size={32} color="#FFFFFF" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;